module.exports = __webpack_public_path__ + "img/nav_queue.87330420.jpg";